import { Show, createMemo, createSignal } from "solid-js";
import { JobQueueStatusInfo, JobState } from "st-app/api";
import { useJobQueueStatusContext } from "../JobQueueStatusContext";
import style from '../st-job-queue-status.module.css'
import { createProxySignal, transformImagePath } from "common";
import Button, { ButtonType } from "../../st-button/st-button";
import { launchRI, viewJob } from "../st-job-queue-status";
import ButtonGroup from "../../st-button-group/st-button-group";
import STCheckbox from "../../st-checkbox/st-checkbox";

export const JobInfoRow = (props: { job: JobQueueStatusInfo, historical?: boolean }) => {
    const jqContext = useJobQueueStatusContext();

    const isCompleted = createMemo(() => {
        if (props.historical) return true;
        return props.job.state === JobState.Complete || props.job.state === JobState.Error;
    })

    const selected = createProxySignal(
        () => jqContext.selectedJobIds().includes(props.job.processQueueGU!),
        (v) => {
            jqContext.toggleSelectedJob(props.job, v)
        }
    )

    return (
        <div class={style['info-row']}>
            <div class={style['info-icon']}>
                <Show when={props.job.recurring}>
                    <STCheckbox label="" value={selected}></STCheckbox>
                </Show>
                <img src={transformImagePath(props.job.statusIcon)} />
            </div>

            <div class={style['info-top-row']}>
                <div class={style['submit-dt']}>{props.job.submitDT}</div>

                <div use:tooltip={props.job.jobID} class={style['job-id']} style='font-weight: bold; text-overflow: ellipsis; overflow-x: hidden;'>
                    {props.job.jobID}
                </div>
                <Show when={props.job.note}>
                    <div class={style['job-note']} style='font-style: italic; text-overflow: ellipsis; overflow-x: hidden;' use:tooltip={{ tooltip: props.job.note ?? '', placement: 'bottom' }}>
                        {props.job.note}
                    </div>
                </Show>
                <div use:tooltip={props.job.description} class={style['job-description']} style='font-weight: bold;'>
                    {props.job.description}
                </div>
            </div>

            <div class={style['info-bottom-row']}>
                {props.job.userJobStatus}
            </div>

            <div class={style['info-actions']}>
                <ButtonGroup>
                    <Show when={!props.job.recurring}>
                        <Button type="success" onClick={() => {viewJob(props.job)}}>View</Button>
                        <Show when={!isCompleted()}>
                            <Button type="danger" onClick={() => { jqContext.abort(props.job) }} icon='fa fa-xmark'>Abort</Button>
                        </Show>

                        <Show when={isCompleted() && !props.historical}>
                            <Button type="danger" onClick={() => { jqContext.dismiss(props.job) }} icon='fa fa-xmark'>Dismiss</Button>
                        </Show>
                    </Show>
                    <Show when={isCompleted() || props.job.recurring}>
                        <Button enabled={!!props.job.reportGU} onClick={() => { launchRI(props.job) }} aria-label="Configure">
                            <i class='fa fa-gear' style='font-size: 11px;'></i>
                        </Button>
                    </Show>
                </ButtonGroup>
            </div>
        </div>
    )
}
